import makeGetPaymentOptionDisabledMessage
from '../../../v2/selectors/PaymentOptionSelectors/makeGetPaymentOptionDisabledMessage';
import makeIsPaymentOptionDisabled from '../../../v2/selectors/PaymentOptionSelectors/makeIsPaymentOptionDisabled';
import makeIsPaymentOptionDisabledByDeliveryOption
from '../../../v2/selectors/PaymentOptionSelectors/makeIsPaymentOptionDisabledByDeliveryOption';
import makeIsPaymentOptionDisabledByOrderSummaryPaymentOptions
from '../../../v2/selectors/PaymentOptionSelectors/makeIsPaymentOptionDisabledByOrderSummaryPaymentOptions';
import makeIsPaymentOptionHidden from '../../../v2/selectors/PaymentOptionSelectors/makeIsPaymentOptionHidden';
import makeIsPaymentOptionHiddenByDeliveryOption
from '../../../v2/selectors/PaymentOptionSelectors/PayOnDelivery/getShouldHidePaymentOptionsIfPayOnDeliverySelected';
import getComponentProps from './getComponentProps';
import getDefaults from './getPaymentOptionDefaults';
import {paymentOptionAttributes} from './paymentOptionAttributes';

export default (paymentOption) => {
  const paymentSpecificAttributes = paymentOptionAttributes(paymentOption);
  
  const shortName = paymentSpecificAttributes.shortName // Short name if defined in payment-specific attributes
    || paymentOption.type.replace('ADYEN-', '').toLowerCase(); // Default shortName
  
  const defaults = {
    ...getDefaults(paymentOption, shortName),
    ...paymentSpecificAttributes,
  };
  
  const getIsOptionDisabledByDeliveryOption = makeIsPaymentOptionDisabledByDeliveryOption(paymentOption.type);
  const getIsOptionDisabledByOrderSummaryPaymentOptions = makeIsPaymentOptionDisabledByOrderSummaryPaymentOptions(
    paymentOption.type,
  );
  const getIsOptionHiddenByDeliveryOption = makeIsPaymentOptionHiddenByDeliveryOption(paymentOption.type);

  return {
    ...defaults,
    componentProps: getComponentProps(defaults, paymentOption),
    getIsDisabled: makeIsPaymentOptionDisabled(getIsOptionDisabledByDeliveryOption,
      getIsOptionDisabledByOrderSummaryPaymentOptions, defaults.getIsDisabled),
    getShouldHide: makeIsPaymentOptionHidden(getIsOptionHiddenByDeliveryOption, defaults.getShouldHide),
    getMessage: makeGetPaymentOptionDisabledMessage(
      getIsOptionDisabledByDeliveryOption, getIsOptionDisabledByOrderSummaryPaymentOptions,
      defaults.paymentName, defaults.getMessage,
    ),
  };
};
